import { attributeDefinitionIdFormat } from "@redotech/redo-product-id";

import { AttributeType } from "@redotech/cockroachdb-codegen/tables/product/attribute-type";
import { OwnerType } from "@redotech/cockroachdb-codegen/tables/product/owner-type";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod";

export const createAttributeDefinition = {
  name: "createAttributeDefinition" as const,
  input: z.object({
    ownerType: createEnum(OwnerType),
    name: z.string().min(1),
    displayName: z.string().min(1),
    description: z.string().optional(),
    type: createEnum(AttributeType),
    enumValues: z.array(z.string()).optional(),
    defaultValue: z.json().optional(),
  }),

  output: z.object({
    attributeDefinitionId: attributeDefinitionIdFormat.schema,
  }),
};
